export default "__VITE_ASSET__Drd6j7VO__"